!(function () {
  "use strict";

  class CartBar extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest("product-info");
      this.form = this.section.querySelector("[data-product-form]");
      this.formWrapper =
        (theme.settings.productPageSticky &&
          this.section.querySelector("[data-form-wrapper]")) ||
        this.form;

      this.handleProductAddError = this.handleProductAddError.bind(this);
      this.boundSetCartBarHeight = this.setCartBarHeight.bind(this);
    }

    connectedCallback() {
      this.setCartBarHeight();
      this.addEventListener("click", this.handleClick.bind(this));
      document.addEventListener("theme:resize", this.boundSetCartBarHeight);
      document.addEventListener("theme:product:add-error", this.handleProductAddError);

      // Show the bar whenever the real ATC button is NOT in the viewport
      // (works both above it — top of page — and below it).
      this.observer = new IntersectionObserver(
        (entries) => {
          const atcInView = entries[0].isIntersecting;
          this.classList.toggle("is-visible", !atcInView);
        },
        { threshold: 0 }
      );
      this.observer.observe(this.formWrapper);
    }

    handleClick(t) {
      const addBtn = t.target.closest("[data-cart-bar-add-to-cart]");
      if (addBtn) {
        t.preventDefault();
        addBtn.classList.add("is-loading");
        addBtn.setAttribute("disabled", "disabled");
        this.form.closest("product-form").onSubmitHandler(t);
      }
      if (t.target.closest("[data-cart-bar-scroll]")) {
        t.preventDefault();
        this.scrollToTop();
      }
    }

    handleProductAddError() {
      if (this.querySelector("[data-cart-bar-add-to-cart]")) {
        this.scrollToTop();
      }
    }

    scrollToTop() {
      const variantSelects = this.section.querySelector("variant-selects");
      const top = (theme.isMobile ? variantSelects || this.form : this.section)
        .getBoundingClientRect().top;
      window.theme.scrollTo(theme.isMobile ? top - 10 : top);
    }

    setCartBarHeight() {
      document.documentElement.style.setProperty(
        "--cart-bar-height",
        `${this.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      document.removeEventListener("theme:product:add-error", this.handleProductAddError);
      document.removeEventListener("theme:resize", this.boundSetCartBarHeight);
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get("cart-bar")) {
    customElements.define("cart-bar", CartBar);
  }
})();